export function toNumOrNull(v) {
  const raw = String(v ?? "").trim();
  if (raw === "" || raw === "-" || raw === "." || raw === "-.") return null;
  const normalized = raw.replace(/,/g, "");
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function numFromAny(v) {
  const raw = String(v ?? "").trim();
  if (!raw) return null;
  const normalized = raw.replace(/,/g, "");
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function inRange(num, min, max) {
  if (!Number.isFinite(num)) return false;
  if (min != null && num < min) return false;
  if (max != null && num > max) return false;
  return true;
}

export function isValidDecimalInput(s) {
  const v = String(s ?? "");
  if (v === "" || v === "-" || v === "." || v === "-.") return true;
  return /^-?\d{0,3}(,\d{3})*(\.\d*)?$|^-?\d*(\.\d*)?$/.test(v);
}

export function fmt(n, digits = 6) {
  const x = Number(n);
  if (!Number.isFinite(x)) return "";
  return x.toFixed(digits);
}

export function nextRowId(rows) {
  if (!rows || rows.length === 0) return 0;
  return Math.max(...rows.map((r) => Number(r.row_id ?? -1))) + 1;
}

export function parseDateSafe(v) {
  if (!v) return null;
  const d = new Date(v);
  return Number.isFinite(d.getTime()) ? d : null;
}

export function parseLocalDateOnly(yyyyMmDd) {
  const s = String(yyyyMmDd ?? "").trim();
  if (!s) return null;
  const parts = s.split("-");
  if (parts.length !== 3) return null;
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  const d = Number(parts[2]);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
  const dateObj = new Date(y, m - 1, d, 0, 0, 0, 0);
  return Number.isFinite(dateObj.getTime()) ? dateObj : null;
}

export function isWithinLocalDateRange(dateObj, fromDateOnly, toDateOnly) {
  if (!dateObj || !Number.isFinite(dateObj.getTime())) return false;

  const time = dateObj.getTime();

  let minTime = -Infinity;
  let maxTime = Infinity;

  if (fromDateOnly && Number.isFinite(fromDateOnly.getTime())) {
    const min = new Date(
      fromDateOnly.getFullYear(),
      fromDateOnly.getMonth(),
      fromDateOnly.getDate(),
      0,
      0,
      0,
      0
    );
    minTime = min.getTime();
  }

  if (toDateOnly && Number.isFinite(toDateOnly.getTime())) {
    const max = new Date(
      toDateOnly.getFullYear(),
      toDateOnly.getMonth(),
      toDateOnly.getDate(),
      23,
      59,
      59,
      999
    );
    maxTime = max.getTime();
  }

  return time >= minTime && time <= maxTime;
}

export function bucketKey(dateObj, period) {
  const y = dateObj.getFullYear();
  const m = dateObj.getMonth() + 1;
  const d = dateObj.getDate();
  const pad2 = (n) => String(n).padStart(2, "0");

  if (period === "day") return `${y}-${pad2(m)}-${pad2(d)}`;

  if (period === "week") {
    const tmp = new Date(dateObj);
    tmp.setHours(0, 0, 0, 0);
    tmp.setDate(tmp.getDate() + 3 - ((tmp.getDay() + 6) % 7));
    const week1 = new Date(tmp.getFullYear(), 0, 4);
    const weekNo =
      1 +
      Math.round(
        ((tmp.getTime() - week1.getTime()) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7
      );
    return `${tmp.getFullYear()}-W${pad2(weekNo)}`;
  }

  return `${y}-${pad2(m)}`;
}

export function asNiceNumber(n, digits = 6) {
  const x = Number(n);
  if (!Number.isFinite(x)) return 0;
  const p = Math.pow(10, digits);
  return Math.round(x * p) / p;
}
